import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface FeeConfig {
  version: number
  thresholdStep: number
  amountStart: number
  amountStep: number
  isFlat: boolean
}

export interface PaymentMethodFees {
  credit: FeeConfig | null
  bank: FeeConfig | null
}

export interface ProcessingFeeConfigs {
  wordwareLunch: PaymentMethodFees
  tuitionContract: PaymentMethodFees
  destinyFine: PaymentMethodFees
  otherFee: PaymentMethodFees
  skywardFee: PaymentMethodFees
  epaytrakCartFee: PaymentMethodFees
  skywardLunch: PaymentMethodFees
  activity: PaymentMethodFees
  affinetyActivityFee: PaymentMethodFees
  insurance: PaymentMethodFees
  primeroLunch: PaymentMethodFees
  titanLunch: PaymentMethodFees
  epaytrakCartItem: PaymentMethodFees
  tuitionLicense: PaymentMethodFees
  childcare: PaymentMethodFees
  creditAccountTransaction: PaymentMethodFees
  assignedDeposit: PaymentMethodFees
  additionalCharge: PaymentMethodFees
  corePowerschoolFee: PaymentMethodFees
  mbaPowerschoolFee: PaymentMethodFees
  mbaCafeLunch: PaymentMethodFees
  processingFee: PaymentMethodFees
}

// GET /processing_fee_configs
export const processingFeeConfigs = async (districtId: TDistrictId) => {
  const response = await new Request().get('/ajax/processing_fee_configs/' + districtId)
  return Util.Obj.keysToCamel(response.data.processing_fee_configs) as ProcessingFeeConfigs
}
